import axios from "./axios";

import {
    API_BASE_URL,
} from '../../env';

// import { ElMessageBox } from "element-plus";

const CHARGER_SESSION_TRUE_VALUES = new Set([true, 1, "1", "true", "yes"]);

function isChargerSessionFlagEnabled(value) {
    if (typeof value === "string") {
        return CHARGER_SESSION_TRUE_VALUES.has(value.trim().toLowerCase());
    }
    return CHARGER_SESSION_TRUE_VALUES.has(value);
}

function isValidChargerSessionMpId(mpId) {
    return mpId != null && mpId !== "" && Number.isFinite(Number(mpId));
}

function formatSessionDateTime(value) {
    if (value == null || value === "") {
        return value;
    }
    const text = String(value).trim().replace("T", " ");
    return text.length >= 19 ? text.substring(0, 19) : text;
}

function isEmptySessionFilterValue(value) {
    return value == null || String(value).trim() === "";
}

function isNonMonthSessionGroupBy(groupBy) {
    return groupBy === 2 || groupBy === 3 || groupBy === 4 || groupBy === "2" || groupBy === "3" || groupBy === "4";
}

function isOverallSessionScope(request) {
    if (!request || !isValidChargerSessionMpId(request.mp_id)) {
        return false;
    }
    return (
        isEmptySessionFilterValue(request.customer_id) &&
        isEmptySessionFilterValue(request.search) &&
        isEmptySessionFilterValue(request.charger_id) &&
        isEmptySessionFilterValue(request.charger_name) &&
        isEmptySessionFilterValue(request.elec_region) &&
        isEmptySessionFilterValue(request.country)
    );
}

function isOverallSessionListRequest(request) {
    return isOverallSessionScope(request) && !isNonMonthSessionGroupBy(request.group_by);
}

function applySessionListScope(body, request) {
    if (!body || !request) {
        return body;
    }
    body.start_date = formatSessionDateTime(body.start_date);
    body.end_date = formatSessionDateTime(body.end_date);
    body.mp_id = isValidChargerSessionMpId(request.mp_id) ? Number(request.mp_id) : null;
    return body;
}

function buildSessionGroupByBody(request) {
    const overall = isOverallSessionScope(request);
    const body = overall
        ? {
            start_date: request.start_date,
            end_date: request.end_date,
            kind: request.kind,
            group_by: request.group_by,
            customer_id: null,
            search: "",
            charger_name: null,
            elec_region: "",
            country: null,
        }
        : {
            start_date: request.start_date,
            end_date: request.end_date,
            kind: request.kind,
            group_by: request.group_by,
            customer_id: request.customer_id,
            charger_name: request.charger_name,
            elec_region: request.elec_region,
            country: request.country,
            search: request.search,
        };
    return applySessionListScope(body, request);
}

// Optional charger inventory filters. Omit flags (or send false) to keep full inventory.
// Never send a flag without mp_id. with_sessions_and_abatement wins when both are true.
function applyChargerSessionFilters(target, request) {
    if (!target || !request || !isValidChargerSessionMpId(request.mp_id)) {
        return target;
    }

    if (isChargerSessionFlagEnabled(request.with_sessions_and_abatement)) {
        target.with_sessions_and_abatement = true;
        target.mp_id = Number(request.mp_id);
        return target;
    }

    if (isChargerSessionFlagEnabled(request.with_sessions)) {
        target.with_sessions = true;
        target.mp_id = Number(request.mp_id);
    }

    return target;
}


class UserService {
    getURL() {
        return API_BASE_URL + "/";
    }
    //#region Dashboard
    DashboardAllData(request) {
        let body = request == null ? {} : request;
        let response = axios.post("api/dashboard-all-data", body);
        return response;
    }

    DashboardHomeData(request) {
        let body = {};
        const fields = [
            "mp_id",
            "customer_id",
            "project_id",
            "country",
            "elec_region",
            "start_date",
            "end_date",
            "kind",
            "site_name",
        ];
        fields.forEach((key) => {
            if (request[key] != null && request[key] !== "") {
                body[key] = request[key];
            }
        });
        let response = axios.post("api/highlights", body);
        return response;
    }

    DashboardSessionsData(request) {
        const overall = isOverallSessionListRequest(request);
        let body = overall
            ? {
                start_date: request.start_date,
                end_date: request.end_date,
                customer_id: null,
                search: "",
                charger_name: null,
                elec_region: "",
                country: null,
            }
            : {
                start_date: request.start_date,
                end_date: request.end_date,
                group_by: request.group_by,
                customer_id: request.customer_id,
                charger_name: request.charger_name,
                elec_region: request.elec_region,
                country: request.country,
            };
        applySessionListScope(body, request);
        let response = axios.post("api/dashboard-session-data", body);
        return response;
    }

    // GetAllChargingSite(request, page, page_size = undefined) {
    //     let body = {
    //         customer_id: request.customer_id,
    //         search: request.search,
    //         state: request.state,
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/all-charging-sites?page=" + params, body);
    //     return response;
    // }

    GetSiteNameDataForDropdown(request) {
        let body = {
            customer_id: request.customer_id,
            start_time: request.start_time,
            end_time: request.end_time,
        };
        let response = axios.post("api/get-sites-for-dropdown", body);
        return response;
    }

    GetAllChargingSite(request, page, page_size = undefined, no_page = false) {
        let body = {
            customer_id: request.customer_id,
            search_by: request.search_by,
            search: request.search,
            elec_region: request.elec_region,
            country: request.country,
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // if (optional !== undefined) {
        //     body.optional_request = optional;
        // }
        // console.log("all charging site response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/all-charging-sites${queryString}`, body);
        return response;
    }


    GetThreeInOneChargerData(request){
        let body = {
            customer_id : request.customer_id
        }
        let response = axios.post(`api/get-three-in-one`, body);
        // console.log("get three in one charger", response);

        return response;
    }

    // region Charger count breakdown cards
    // api/charger-count-breakdown
    GetChargerCountBreakdown(request = {}){
        const params = {};
        if (request && request.customer_id != null && request.customer_id !== "") {
            params.customer_id = request.customer_id;
        }
        applyChargerSessionFilters(params, request);
        return axios.get("api/charger-count-breakdown", { params });
    }

    // POST /api/clear-session-charger-cache
    // Admin only. Always send mp_id so a dashboard click cannot wipe every MP.
    ClearSessionChargerCache(request = {}) {
        const body = {};
        if (request && isValidChargerSessionMpId(request.mp_id)) {
            body.mp_id = Number(request.mp_id);
        }
        if (
            request &&
            (request.endpoint === "charger-count-breakdown" ||
                request.endpoint === "charger-distributions")
        ) {
            body.endpoint = request.endpoint;
        }
        return axios.post("api/clear-session-charger-cache", body);
    }

    // POST /api/clear-session-list-cache
    // Admin only. Always send mp_id so a click cannot wipe every monitoring period.
    ClearSessionListCache(request = {}) {
        const body = {};
        if (request && isValidChargerSessionMpId(request.mp_id)) {
            body.mp_id = Number(request.mp_id);
        }
        if (
            request &&
            (request.endpoint === "session-list-card" ||
                request.endpoint === "session-log-list-card" ||
                request.endpoint === "dashboard-session-data" ||
                request.endpoint === "dashboard-session-group-by-card" ||
                request.endpoint === "dashboard-session-group-by-table")
        ) {
            body.endpoint = request.endpoint;
        }
        return axios.post("api/clear-session-list-cache", body);
    }

    // GET /api/mp-charger-counts?mp_id=&customer_id=&with_sessions=&with_sessions_and_abatement=
    // mp_id is always required. customer_id is admin-only when a customer is selected.
    // Session flags match charger-count-breakdown; omit them (or false) for full inventory.
    GetMpChargerCounts(request = {}) {
        const params = {};
        if (request && isValidChargerSessionMpId(request.mp_id)) {
            params.mp_id = Number(request.mp_id);
        }
        if (request && request.customer_id != null && request.customer_id !== "") {
            params.customer_id = request.customer_id;
        }
        applyChargerSessionFilters(params, request);
        return axios.get("api/mp-charger-counts", { params });
    }
    // region End

    //#region Dashboard Estimator
    // DashboardEstimator start
    DashboardEstimator(request) {

        if (!request) {
            console.error("Invalid request object:", request);
            return;
        }
        // console.log("Request body:", JSON.stringify(request));
        return axios.post("api/estimator/", request);
    }

    DashboardEstimatorFilter() {
        console.log("Getting filter data...");
        return axios.get("api/filterbylocation/");
    }

    // DashboardEstimator end

    // Dashboard auditor-reports start

    //#region Auditor Reports

    DashboardAuditorReports(request, page, page_size = undefined, no_page = false) {

        let body = request;
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("project instance response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/auditor-reports${queryString}`, body);
        return response;
    }

    // new verra reports endpoint, insead of separate endpoints for each report type
    // NewVerraReports(request, page = undefined, page_size = undefined, no_page = false) {
    //     let body = request;
    //     let params = [];
    //     if (page == undefined) {
    //         params.push('page=1');
    //     }
    //     if (page !== undefined) {
    //         params.push(`page=${page}`);
    //     }
    //     if (page_size !== undefined) {
    //         params.push(`page_size=${page_size}`);
    //     }
    //     if (no_page) {
    //         params.push('no_page=true'); // Bypass pagination
    //     }
    //     // console.log("project instance response:", params);
    //     let queryString = params.length > 0 ? '?' + params.join('&') : '';
    //     let response = axios.post(`api/verra-reports${queryString}`, body);
    //     return response;
    // }

    // getVerraReportByEq(request, eq, page = undefined, page_size = undefined, no_page = false) {
    //     let body = request;
    //     let params = [];
    //     if (page == undefined) {
    //         params.push('page=1');
    //     }
    //     if (page !== undefined) {
    //         params.push(`page=${page}`);
    //     }
    //     if (page_size !== undefined) {
    //         params.push(`page_size=${page_size}`);
    //     }
    //     if (no_page) {
    //         params.push('no_page=true'); // Bypass pagination
    //     }
    //     // console.log("project instance response:", params);
    //     let queryString = params.length > 0 ? '?' + params.join('&') : '';
    //     let response = axios.post(`api/verra-reports/${eq}/${queryString}`, body);
    //     return response;
    // }

    getProjectInstance(request, search, page, page_size = undefined, no_page = false) {
        let body = {
            search: search
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("project instance response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/project-instances${queryString}`, body);
        return response;
    }

    // clear cache verra reports
    // ClearVerraReportsCache(clear_all = undefined, mp_id = undefined) {
    //     let data = {mp_id}
    //     if(clear_all && clear_all == true){
    //         let response = axios.post("api/clear-verra-cache?clear_all=true", data);
    //         return response;
    //     }
    //     let response = axios.post("api/clear-verra-cache");
    //     return response;
    // }

    // ClearAuditorReportsCache(mp_id = undefined) {
    //     let data = {mp_id}
    //     let response = axios.post("api/clear-auditor-reports-cache", data);
    //     return response;
    // }

    // clear highlights cache home page
    ClearHighlightsCache(request = {}) {
        const listKeys = request === true || request.list_keys === true;
        let url = "api/clear-highlights-cache";
        if (listKeys) {
            url += "?list_keys=true";
        }
        let body = {};
        if (request && request !== true) {
            if (request.customer_id != null && request.customer_id !== "") {
                body.customer_id = request.customer_id;
            }
            if (request.mp_id != null && request.mp_id !== "") {
                body.mp_id = request.mp_id;
            }
        }
        return axios.post(url, body);
    }

    DashboardAuditorReportsTest() {
        return axios.get("api/auditor-reports");
    }

    //#region End Auditor and Verra Reports




    //#region DMRV
    // eslint-disable-next-line no-unused-vars
    getVerraMonitoringReportsList(request) {
        if (request == undefined || request.selected_send_mp_name == "") {

            // fetch verramp list
            let response = axios.post("api/verra-mp-list");
            // console.log("request without body",request);
            return response;

            // case 2: success
            // return new Promise((resolve) => {
            //     resolve({
            //         code: 1000,
            //         data: [
            //             {
            //                 id: "a8f81c17-b077-4aee-9022-c0602d256686",
            //                 projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //                 standardTemplate: "vcs",
            //                 standardTemplateName: "VCS Monitoring Report v4.3",
            //                 methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //                 monitoringReportName: "testMP234",
            //                 projectName: "Motion Energy EV Industry Charger Project",
            //                 submissionStatus: "Draft"
            //             },
            //             {
            //                 id: "da2da167-f47d-44e4-a96c-4319fa7ec0ac",
            //                 projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //                 standardTemplate: "vcs",
            //                 standardTemplateName: "VCS Monitoring Report v4.3",
            //                 methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //                 monitoringReportName: "testMP23",
            //                 projectName: "Motion Energy EV Industry Charger Project",
            //                 submissionStatus: "Draft"
            //             },
            //             {
            //                 id: "f99e2977-60fb-4822-912e-1a7869e46301",
            //                 projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //                 standardTemplate: "vcs",
            //                 standardTemplateName: "VCS Monitoring Report v4.3",
            //                 methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //                 monitoringReportName: "testMP2",
            //                 projectName: "Motion Energy EV Industry Charger Project",
            //                 submissionStatus: "Draft"
            //             },
            //             {
            //                 id: "503e26d5-f32e-4b21-8417-2ef494413ced",
            //                 projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //                 standardTemplate: "vcs",
            //                 standardTemplateName: "VCS Monitoring Report v4.3",
            //                 methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //                 monitoringReportName: "testMP",
            //                 projectName: "Motion Energy EV Industry Charger Project",
            //                 submissionStatus: "Draft"
            //             },
            //             {
            //                 id: "964c1254-6f5a-4d56-bf90-6dc230eae926",
            //                 projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //                 standardTemplate: "vcs",
            //                 standardTemplateName: "VCS Monitoring Report v4.3",
            //                 methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //                 monitoringReportName: "Test Monitoring Report2023_SN",
            //                 projectName: "Motion Energy EV Industry Charger Project",
            //                 submissionStatus: "Draft"
            //             },
            //             {
            //                 id: "77d1539d-77da-47ff-94bd-d6e1143f155e",
            //                 projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //                 standardTemplate: "vcs",
            //                 standardTemplateName: "VCS Monitoring Report v4.3",
            //                 methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //                 monitoringReportName: "New Template MRP 1 Dec 2021 to 31 Dec 2022",
            //                 projectName: "Motion Energy EV Industry Charger Project",
            //                 submissionStatus: "Draft"
            //             }
            //         ],
            //         message: "Monitoring report found."
            //     });
            // });


        } else {

            // send mp_name
            let body = {
                mp_name: request.selected_send_mp_name,
            };
            let response = axios.post("api/verra-mp-list", body);
            // console.log("send request body", body);
            return response;

            // case 2: success
            // return new Promise((resolve) => {
            //     resolve( {
            //         data: {
            //         code: 1000,
            //         data: {
            //             id: "2e8e7ceb-d53a-4f04-83eb-8ecf9d778f0b", // send to post
            //             projectId: "c7999913-4042-43a2-a6a6-875cdecde756",
            //             standardTemplate: "vcs",
            //             standardTemplateName: "VCS Monitoring Report v4.3",
            //             methodologyTemplate: "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
            //             monitoringReportName: "testMP2345",
            //             projectName: "Motion Energy EV Industry Charger Project",
            //             submissionStatus: "Draft"
            //         },
            //         message: "Monitoring report found."
            //     }});
            // });

            // return new Promise((resolve) => {
            //     resolve( {
            //         data: {
            //         code: 1002,
            //         data: [],
            //         message: "No monitoring report found with name {}."
            //     }});
            // });

        }

    }

    VerraSendMonitoringReportsShayan(request) {
        let body = {
            verra_mp_id: request.verra_mp_id_from_response,
            mp_id: request.mp_id,
            mp_name: request.mp_name,
            start_date: request.start_date,
            end_date: request.end_date
        };
        let response = axios.post("api/verra-send-mp-json", body);
        // console.log("verra-send-mp-json body",body);
        // console.log("verra send response", response);

        return response;

        // moce response for testing case 1: 1001
        // return new Promise((resolve) => {
        //     resolve({data:{
        //         code: 1001,
        //         data: [],
        //         message: "You are not allowed to use this method, please contact the administrator",
        //     }});
        // });

        // case 2: 1000

        // return new Promise((resolve) => {
        //     const message = ["Sending monitoring report data failed with status code {}",
        //         "Submitting monitoring period failed with status code {}",
        //         "calculate err failed with status code {}",
        //         "Sent monitoring report data, submit monitoring report, and calculate err requests submitted successfully. Please wait 10-15 minutes."
        //     ]
        //     const min = 0;
        //     const max = 3;
        //     const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

        //     resolve({data:{
        //         code: 1000,
        //         data: [],
        //         message: message[randomNumber],
        //     }});
        // });


    }

    VerraCreateMonitoringPeriod(request) {
        let body = {
            mp_name: request.selected_mp_name,
        };
        let response = axios.post("api/verra-mp-create", body);

        return response;

        // mock response for testing:
        // case 1: failed
        // return new Promise((resolve) => {
        //     resolve({
        //         success: false,
        //         message: "Failed to create monitoring period.",
        //         data: {
        //             failed: [
        //                 "Monitoring Report Name already exists."
        //             ]
        //         },
        //     });
        // });

        // case 2: success
        // return new Promise((resolve) => {
        //     resolve({
        //         success: true,
        //         message: "Monitoring period created successfully.",
        //         data: {
        //             id : "2e8e7ceb-d53a-4f04-83eb-8ecf9d778f0b",
        //             monitoringReportName: "testMP2345",
        //             monitoringPeriod: {
        //                 startDate: "2021-01-01T00:00:00",
        //                 endDate: "2023-01-01T23:59:59"
        //             }
        //         },
        //     });
        // });


    }

    DmrvGetProjectDescription() {
        let response = axios.get("api/dmrv-project-descrp");
        return response;
        // return new Promise((resolve) => {
        //         resolve({
        //             code: 1000,
        //             data: [
        //                 {
        //                     "id": "078ecad9-4362-4260-9347-7e7c0f51b6f5",
        //                     "standardTemplate": "vcs",
        //                     "standardTemplateName": "VCS Project Description v4.3",
        //                     "methodologyTemplate": "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
        //                     "projectName": "DMRV test Project Description",
        //                     "submissionStatus": "Draft"
        //                 },
        //                  {
        //                     "id": "078ecad9-4362-4260-9347-7e7c0f51b6f5",
        //                     "standardTemplate": "vcs",
        //                     "standardTemplateName": "VCS Project Description v4.3",
        //                     "methodologyTemplate": "VM0038 - Methodology for Electric Vehicle Charging Systems Version 1.0",
        //                     "projectName": "DMRV test Project Description",
        //                     "submissionStatus": "Draft"
        //                 },
        //             ],
        //             message: "Monitoring report found."
        //         });
        //     });
    }

    // get verra pdf by verra_mp_id
    verraTableAction(verra_mp_id, action){
        if(action == "pdf"){
            let response = axios.get("api/verra-download-mp-pdf?verra_mp_id=" + verra_mp_id);
            return response;
        } else if(action == "view-more"){
            let response = axios.post("api/verra-calculate-err?verra_mp_id=" + verra_mp_id);
            return response;
        }
    }

    //#region end DMRV

    // Dashboard auditor-reports end

    //#region Snapshot
    // auditor reports snapshot
    // DashboardAuditorReportsTestSnapshot(){
    //     let response = axios.get("api/snapshot-auditor-report");
    //     return response;
    // }

    SnapshotReport(request){
        let requestData = {

            log_date: request.log_date,
            form_kind: request.form_kind,
            action_kind: request.action_kind,
            document_id: request.document_id,
            comment: request.comment,
            before_change: request.before_change,
        }

        // console.log("Snapshot request data:", requestData);


        if(requestData.before_change.length === 0){
            return Promise.resolve({
                success: false,
                message: `Snapshot request not success! ${requestData.comment} is empty!`,
            });

        } else {
            // let response = axios.post("api/snapshot-report", requestData);
            // return response;
            return axios.post("api/snapshot-report", requestData).then((response) => {

                return {
                    success: true,
                    message: `Snapshot request success! ${requestData.comment} created successfully!`,
                    response: response,
                }
            }).catch((error) => {
                console.error("Error while creating snapshot report:", error);

                return {
                    success: false,
                    message: `Snapshot request not success! ${requestData.comment} not successfully!`,
                    error: error,
                }
            });
        }

    }

    getSnapshotList(page, filter, page_size = undefined) {
        let body = filter
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/snapshot-list?page=" + params, body);
        return response;
    }

    newSnapshotRequest(request, page, page_size = undefined, no_page = false ){
        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            report_type: "",
            current_page: null,
            perPageCount: null,
            no_page: true,
            search: ""
        }

        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }

        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/new-snapshot-report${queryString}`, body);
        return response;
    }

    // fetch snapshot log table data by snapshot log id
    getSnapshotById(request) {
        let body = {
            id: request.id,
        };
        let response = axios.post("api/snapshot-get-by-id", body);
        return response;
    }

    // auditor reports snapshot end
    //#endregion

    //#region Overlapping Sessions
    // eslint-disable-next-line no-unused-vars
    OverlappingSessionsAnalytics(request) {
        let body = request;
        let response = axios.get("api/overlap-analytics", body);
        return response;
    }

    OverlappingSessionsRunOverlapCheck(request) {
        let body = request;
        let response = axios.post("api/run-overlap-check", body);
        return response;
    }

    OverlappingSessionRemoveOverlaps(request) {
        let body = {
            action_kind: request
        };
        let response = axios.post("api/remove-overlaps", body);
        return response;
    }
    //#endregion

    // region sessions group by
    DashboardSessionGroupBy(request) {
        const controller = new AbortController();
        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            kind: request.kind,
            group_by: request.group_by,
            customer_id: request.customer_id,
            charger_name: request.charger_name,
            elec_region: request.elec_region,
            country: request.country,
            search: request.search,
        };
        let response = axios.post("api/dashboard-session-group-by", body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }

    DashboardSessionGroupByCard(request) {
        const controller = new AbortController();
        const body = buildSessionGroupByBody(request);
        let response = axios.post("api/dashboard-session-group-by-card", body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }

    DashboardSessionGroupByTable(request) {
        const controller = new AbortController();
        const body = buildSessionGroupByBody(request);
        let response = axios.post("api/dashboard-session-group-by-table", body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }
    //#endregion


    // DashboardCharger get xlsx file
    DashboardChargersXlsx() {

        let response = axios.post("api/export-chargerschedule-excel", {}, {
            responseType: 'blob'
        });
        return response;

    }

    //#region Charger Anomally
    // Charger Anomally get duplicate_of_id for charger site map
    DashboardChargerMapDuplicate() {
        let response = axios.get("api/get-charger-anomaly");
        return response;
    }

    // #region group sites by distance
    /**
     * POST grouped-duplicate-sites.
     * @param {number} [distance]
     * @param {number[]|number} customer_id Customers to include. Always sent as number[] (non-empty).
     *   A single id is wrapped as [id].
     * @param {string} [elec_region] Same rule as other location filters. Send "All" and "N/A" as-is.
     * @param {string} [country] Same rule as other location filters. "" or omit when cleared.
     * @param {number[]} [excluding_customer_ids] Optional. Customers omitted from central sites and nearby matches.
     *   Omitted from the body when empty. If an id is in both lists, exclude wins.
     */
    ChargerMapGroupByDistance( distance = undefined, customer_id = undefined, elec_region = undefined, country = undefined, excluding_customer_ids = undefined) {
        const ids = Array.isArray(customer_id)
            ? customer_id
            : (customer_id != null && customer_id !== "" ? [customer_id] : []);
        const customerIds = ids
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && !Number.isNaN(id));

        const excludeIds = Array.isArray(excluding_customer_ids)
            ? excluding_customer_ids
            : (excluding_customer_ids != null && excluding_customer_ids !== "" ? [excluding_customer_ids] : []);
        const excludingCustomerIds = excludeIds
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && !Number.isNaN(id));

        let body = {
            customer_id: customerIds,
            country: country != null ? String(country) : "",
            elec_region: elec_region != null ? String(elec_region) : "",
        };
        if (excludingCustomerIds.length > 0) {
            body.excluding_customer_ids = excludingCustomerIds;
        }
        if (distance != null && distance !== "") {
            const parsedDistance = Number(distance);
            if (!Number.isNaN(parsedDistance)) {
                body.distance = parsedDistance;
            }
        }

        let response = axios.post("api/grouped-duplicate-sites", body);
        return response;
    }

    // get all states
    ChargerMapGroupGetStates() {
        let response = axios.get("api/grouped-duplicate-sites");
        return response;
    }

    DashboardChargersData(request) {
        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
            elec_region: request.elec_region,
            country: request.country,
        };
        applyChargerSessionFilters(body, request);
        let response = axios.post("api/dashboard-chargers-data", body);
        return response;
    }

    ChargersDistributions(request) {
        let body = {
            customer_id: request.customer_id,
            elec_region: request.elec_region,
            country: request.country,
        };
        applyChargerSessionFilters(body, request);
        let response = axios.post("api/charger-distributions", body);
        return response;
    }

    // GetAllCharger(request, page, page_size = undefined) {
    //     let body = {
    //         customer_id: request.customer_id,
    //         search: request.search,
    //         state: request.state,
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/all-chargers?page=" + params, body);
    //     return response;
    // }

    GetAllCharger(request, page, page_size = undefined, no_page = false) {
        let body = {
            customer_id: request.customer_id,
            search_by: request.search_by,
            search: request.search,
            elec_region: request.elec_region,
            country: request.country,
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("all charger response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/all-chargers${queryString}`, body);
        return response;
    }

    GetChargerSelection(request) {
        let body = {
            customer_id: request.customer_id,
            search: request.search
        };
        let response = axios.post("api/charger-list-selection", body);
        return response;
    }

    // GetAllPort(request, page, page_size = undefined) {
    //     let body = {
    //         customer_id: request.customer_id,
    //         search: request.search,
    //         state: request.state,
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/all-ports?page=" + params, body);
    //     return response;
    // }

    GetAllPort(request, page, page_size = undefined, no_page = false) {
        let body = {
            customer_id: request.customer_id,
            search_by: request.search_by,
            search: request.search,
            elec_region: request.elec_region,
            country: request.country,
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // if (optional !== undefined) {
        //     body.optional_request = optional;
        // }
        // console.log("all port response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        // console.log("body:", body);

        let response = axios.post(`api/all-ports${queryString}`, body);
        return response;
    }

    GetChargerList(request, page, page_size = undefined, no_page = false) {

        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
            search_by: request.search_by,
            search: request.search,
            elec_region: request.elec_region,
            charging_site_id: request.charging_site_id,
            country: request.country,
        };
        applyChargerSessionFilters(body, request);

        if(no_page == true) {
            let response = axios.post("api/charger-list?no_page=true", body);
            return response;
        }

        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/charger-list?page=" + params, body);
        return response;
    }

    GetTopPerformingSites(request, page, page_size = undefined) {
        let body = {
            customer_id: request.customer_id,
            elec_region: request.elec_region,
            country: request.country,
            start_date: request.start_date,
            end_date: request.end_date,
        };
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/top-performing-sites?page=" + params, body);
        return response;
    }

// region sessions table
    GetSessionList(request, page, page_size = undefined) {
        const controller = new AbortController();

        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
            charger_name: request.charger_name,
            search: request.search,
            search_by: request.search_by,
            elec_region: request.elec_region,
            country: request.country,
        };

        let response;
        if (page_size != 0) {
            let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
            response = axios.post("api/session-list?page=" + params, body, { signal: controller.signal });
        } else {
            response = axios.post("api/session-list?bypass_pagination=true", body, { signal: controller.signal });
        }

        // Return both the response and the controller so the caller can cancel if needed
        return {
            response: response,
            controller: controller
        };
    }

    GetSessionListTable(request, page, page_size = undefined) {
        const controller = new AbortController();

        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
            charger_name: request.charger_name,
            search: request.search,
            search_by: request.search_by,
            elec_region: request.elec_region,
            country: request.country,
        };

        const params = [];
        params.push(`page=${page == undefined ? 1 : page}`);
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }

        let response = axios.post(`api/session-list-table?${params.join('&')}`, body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }

    GetSessionListCard(request) {
        const controller = new AbortController();
        const overall = isOverallSessionListRequest(request);

        let body = overall
            ? {
                start_date: request.start_date,
                end_date: request.end_date,
                customer_id: null,
                charger_name: null,
                search: "",
                search_by: request.search_by,
                elec_region: "",
                country: null,
            }
            : {
                start_date: request.start_date,
                end_date: request.end_date,
                customer_id: request.customer_id,
                charger_name: request.charger_name,
                search: request.search,
                search_by: request.search_by,
                elec_region: request.elec_region,
                country: request.country,
            };
        applySessionListScope(body, request);

        let response = axios.post("api/session-list-card", body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }

    GetSessionWithAbatement(request, page, page_size = undefined) {

        let command = request.command || "fetch";
        if (command == "fetch") {
            let body = {
                command: command,
                customer_id: request.customer_id,
                internal_session_id: request.internal_session_id,
            }
            let response = axios.post("api/session-list-with-abatement-params", body);
            return response;
        } else if (command == "download") {
            let body = {
                command: command,
                customer_id: request.customer_id,
                start_date: request.start_date,
                end_date: request.end_date,
                charger_name: request.charger_name,
                search: request.search,
                search_by: request.search_by,
                elec_region: request.elec_region,
                country: request.country,
            }
            let response;
            if (page_size != 0) {
                let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
                response = axios.post("api/session-list-with-abatement-params?page=" + params, body);
            }
            // Return both the response and the controller so the caller can cancel if needed
            return response;
        }
    }

    // region unallocated sessions table
    // region unallocated sessions table
    GetPendingSessionListTable(request, page, page_size = undefined) {
        const controller = new AbortController();

        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
            charger_id: request.charger_id ?? (request.charger_name == null || request.charger_name == "" ? null : request.charger_name),
            search: request.search,
            search_by: request.search_by,
        };

        let response;
        if (page_size != 0) {
            const params = [];
            params.push(`page=${page == undefined ? 1 : page}`);
            if (page_size !== undefined) {
                params.push(`page_size=${page_size}`);
            }
            response = axios.post(`api/session-log-list-table?${params.join('&')}`, body, { signal: controller.signal });
        } else if (request.download_command == "recent") {
            response = axios.post("api/session-log-list-table?recent=true", body, { signal: controller.signal });
        } else {
            response = axios.post("api/session-log-list-table?bypass_pagination=true", body, { signal: controller.signal });
        }

        return {
            response: response,
            controller: controller
        };
    }

    GetPendingSessionListCard(request) {
        const controller = new AbortController();
        const overall = isOverallSessionListRequest(request);
        const chargerId = request.charger_id ?? (request.charger_name == null || request.charger_name == "" ? null : request.charger_name);

        let body = overall
            ? {
                start_date: request.start_date,
                end_date: request.end_date,
                customer_id: null,
                charger_id: null,
                search: "",
                search_by: request.search_by,
            }
            : {
                start_date: request.start_date,
                end_date: request.end_date,
                customer_id: request.customer_id,
                charger_id: chargerId,
                search: request.search,
                search_by: request.search_by,
            };
        applySessionListScope(body, request);

        let response = axios.post("api/session-log-list-card", body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }

    GetPendingSessionList(request, page, page_size = undefined) {
        const controller = new AbortController();

        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
            charger_id: request.charger_name == null || request.charger_name == "" ? null : request.charger_name,
            search: request.search,
            search_by: request.search_by,
            kind: request.kind,
            state: request.state,
            download_command: request.download_command || "default",
        };

        console.log("body", body);
        

        let response;
        if (page_size != 0) {
            let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
            response = axios.post("api/session-log-list?page=" + params, body, { signal: controller.signal });
            console.log("response", "api/session-log-list?page=" + params, body, { signal: controller.signal });
        } else {
            if (body.download_command == "recent") {
                response = axios.post("api/session-log-list?recent=true", body, { signal: controller.signal });
                console.log("response", "api/session-log-list?recent=true", body, { signal: controller.signal });
            } else if (body.download_command == "currentMP") {
                response = axios.post("api/session-log-list?current_mp=true", body, { signal: controller.signal });
                console.log("response", "api/session-log-list?current_mp=true", body, { signal: controller.signal });
            } else {
                response = axios.post("api/session-log-list?bypass_pagination=true", body, { signal: controller.signal });
                console.log("response", "api/session-log-list?bypass_pagination=true", body, { signal: controller.signal });
            }
        }

        // Return both the response and the controller so the caller can cancel if needed
        return {
            response: response,
            controller: controller
        };
    }

    // REALLOCATE UNALLOCATED SESSIONS
    ReallocateUnallocatedSessions(customer_id=undefined, register_id=undefined) {
        if (!customer_id || customer_id == null || customer_id == "") {
            console.error("Customer ID is required");
            return;
        }
        if (!register_id || register_id == null || register_id == "") {
            console.error("Register ID is required");
            return;
        }
        try {
            let response = axios.post("api/reallocate-sessions", {
                customer_id: customer_id,
                register_id: register_id,
            });
            return response;
        } catch (error) {
            console.error("Error when reallocating unallocated sessions", error);
            return;
        }
    }
    // region unallocated sessions END

    GetAbatementHistory(request) {
        try {
            let body = {
                customer_id: request.customer_id,
                start_date: request.start_date,
                end_date: request.end_date,
                state: request.state,
            };
            let response = axios.post("api/abatement-history", body);
            return response;

        } catch (error) {
            console.log("error when fetching abatement History", error);

        }

    }

    newRefreshAbatementHistory() {
        try {
            let response = axios.post("api/new-abatement-history");
            return response;

        } catch (error) {
            console.log("error when fetching abatement History", error);

        }
    }

    newfetchAbatementHistory() {
        try {

            let response = axios.get("api/new-abatement-history");
            return response;

        } catch (error) {
            console.log("error when fetching abatement History", error);

        }
    }


    // eslint-disable-next-line no-unused-vars
    GetLiveAbatementList(request, page, page_size = undefined) {
        let body = {
            customer_id: request.customer_id,
            start_date: request.start_date,
            end_date: request.end_date,
            search_by: request.search_by,
            search: request.search,
            elec_region: request.elec_region,
            country: request.country,
        };
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/get_live_abt?page=" + params, body);
        return response;
    }


    GetCompareDailyEmissions(request) {
        let body = {
            customer_id: request.customer_id,
            start_date: request.start_date,
            end_date: request.end_date,
        };
        // let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/compare-daily-emissions", body);
        return response;
    }



    GetAllInOne(request, page, page_size = undefined) {
        const params = {
            page: page == undefined ? 1 : page,
        };
        if (page_size != undefined) {
            params.page_size = page_size;
        }
        if (request) {
            if (request.customer_id != null && request.customer_id !== "") {
                params.customer_id = request.customer_id;
            }
            if (request.search != null && request.search !== "") {
                params.search = request.search;
            }
            if (request.start_time != null && request.start_time !== "") {
                params.start_time = request.start_time;
            }
            if (request.end_time != null && request.end_time !== "") {
                params.end_time = request.end_time;
            }
            if (request.mp_id != null && request.mp_id !== "") {
                params.mp_id = request.mp_id;
            }
        }
        return axios.get("api/all-in-one", { params });
    }

    RefreshAllInOne(request, page, page_size = undefined) {
        const params = {
            page: page == undefined ? 1 : page,
        };
        if (page_size != undefined) {
            params.page_size = page_size;
        }
        const body = {};
        if (request != null && request.mp_id != null && request.mp_id !== "") {
            body.mp_id = request.mp_id;
        }
        return axios.post("api/all-in-one", body, { params });
    }

    // eslint-disable-next-line no-unused-vars
    GetInvalidSessionList(request, page, page_size = undefined) {
        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            search: request.search,
            customer_id: request.customer_id,
        };
        let response = axios.post("api/dashboard-session-count", body);
        return response;
    }

    GetSessionTimeOfDayList(request) {
        let body = {
            start_date: request.start_date,
            end_date: request.end_date,
            by: request.by,
            customer_id: request.customer_id,
            group_by_item: request.group_by_item,
            count: request.count,
        };
        // console.log(body)
        let response = axios.post("api/dashboard-session-Time-of-day-count", body);
        return response;
    }

    GetOperationsGrowthList(request) {
        let body = {
            by: request.by,
            customer_id: request.customer_id,
            count: request.count,
        };
        let response = axios.post("api/operation-growth-trends", body);
        return response;
    }

    GetInfrastructureGrowthList(request) {
        let body = {
            by: request.by,
            customer_id: request.customer_id,
            count: request.count,
        };
        let response = axios.post("api/infrastructure-growth-trends", body);
        return response;
    }

    //#endregion

    //#region Charger
    setChargers(request, filename="") {
        let body = {
            by_panel: true,
            content: request,
            filename,
        };
        let response = axios.post("api/upload-excel-json", body);
        return response;
    }

    // admin charger upload
    adminUploadChargers(request, customer_id = undefined, filename = "") {
        if (customer_id == undefined || customer_id == null || customer_id == "") {
            console.error("Customer ID is required");
            return;
        } else {
            let body = {
                by_panel: true,
                content: request,
                customer_id,
                filename,
            };
            let response = axios.post("api/upload-excel-json", body);
            return response;
        }

    }

    setSimpleChargerUpload(request, filename="") {
        request.append("filename", filename);
        let response = axios.post("api/simple-upload-charger-file", request);
        return response;
    }
    //#endregion

    //#region Session Upload
    setSessions(request, filename="") {
        let body = {
            by_panel: true,
            content: request,
            filename,
        };
        let response = axios.post("api/upload-session-log-json", body);
        return response;
    }
    setOnSiteRenewables(request, customer_id=null) {
        let body = {
            by_panel: true,
            content: request,
            customer_id,
        };
        let response = axios.post("api/upload-onsite-renewable-bulk", body);
        return response;
    }

    // region celery task
    checkCeleryTaskStatus(taskId) {
        let response = axios.get(`api/celery/task/${taskId}/`);
        return response;
    }

    checkMultipleCeleryTaskStatus(taskIds) {
        if (taskIds.length === 0) {
            console.log("No task IDs provided");
            return;
        }
        let body = {
            task_ids: taskIds
        };
        let response = axios.post(`api/celery/tasks/`, body);
        return response;
    }
    // endregion celery task

    setSimpleSessionUpload(request, filename="") {
        request.append("filename", filename)
        let response = axios.post("api/simple-upload-session-file", request);
        return response;
    }

    // Big Session upload
    uploadSessionFile(request, filename="") {
        request.append("filename", filename);
        let response = axios.post("api/upload_file", request, {"Content-Type": "application/form"});
        return response;
    }

    // admin session upload (small size)
    adminUploadSessionFile(request, customer_id = undefined, filename = "") {
        if (customer_id == undefined || customer_id == null || customer_id == "") {
            console.error("Customer ID is required");
            return Promise.reject(new Error("Customer ID is required"));
        } else {
            let body = {
                content: request,
                customer_id,
                filename,
            };
            let response = axios.post("api/upload-session-log-json", body);
            return response;
        }
    }

    // admin session upload (big session upload)
    adminBigSessionFile(request, customer_id = undefined, filename="") {
        if (customer_id == undefined || customer_id == null || customer_id == "") {
            console.error("Customer ID is required");
            return Promise.reject(new Error("Customer ID is required"));
        } else {
            request.append("customer_id", customer_id);
            request.append("filename", filename);
            let response = axios.post("api/upload_file", request);
            return response;
        }
    }

    getSummerySessionLogByError(request, page, page_size = undefined) {
        let body = request;
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/summery-session-log-by-error-list?page=" + params, body);
        return response;
    }

    sessionLogRemoveBy(request) {
        let body = request;
        let response = axios.post("api/session-log-remove-by", body);
        return response;
    }

    AbatementCalculate(request) {
        if(request.reset_abatement == true || request.reset_abatement == "true") {
            let body = {
                customer_id: request.customer_id,
                reset_abatement: true,
                charger_name: request.charger_name || null,
                site_name: request.site_name || null,
            };
            if (request.mp_id != null) {
                body.mp_id = request.mp_id;
            } else {
                return Promise.reject(new Error("Monitoring period ID is required"));
            }
            console.log("reset abatement body:", body);
            let response = axios.post("api/abatement-calculator", body);
            return response;
        } else {
            let body = {
                customer_id: request.customer_id
            };
            if (request.mp_id != null) {
                body.mp_id = request.mp_id;
            } else {
                return Promise.reject(new Error("Monitoring period ID is required"));
            }
            console.log("abatement calculate body:", body);
            let response = axios.post("api/abatement-calculator", body);
            return response;
        }
    }



    // delete session
    GetUniqueChargerId(request) {
        let body = {
            charging_site_id: request.charger_site_id,
            charger_name : request.charger_name
        };

        let response = axios.post("api/get-unique-charger-id", body);
        return response;
    }

    // delete session by unique charger id
    DeleteSessionsByUniqueChargerId(request) {
        let body = {
            type: request.type,
            customer_id: request.customer_id,
            charger_id: request.uniq_charger_id,
            start_date: request.startDate,
            end_date: request.endDate
        };

        // console.log("DeleteSessionsByUniqueChargerId body:", body);


        let response = axios.post("api/delete-all-sessions", body);
        // let response = {"delete submiteed": body};
        return response;

    }

    // delete unallocated session
    DeleteUnallocatedSession(request) {
        const command = request.command;
        if (command === "fetch") {
            let body = {
                command: command,
                customer_id: request.customer_id,
                start_date: request.start_date,
                end_date: request.end_date
            };
            // console.log("unallocated delete fetch command body:", body);
            let response = axios.post("api/delete-unallocated-sessions", body);
            return response;

        } else if (command === "delete") {
            let body = {
                command: command,
                delete_by: request.delete_by,
                customer_id: request.customer_id,
                charger_name : request.charger_name,
                site_name : request.site_name,
                port_name : request.port_name,
                start_time: request.start_time,
                end_time: request.end_time,
                mp_id: request.mp_id,
            };
            // console.log("unallocated session delete command body:", body);
            let response = axios.post("api/delete-unallocated-sessions", body);
            return response;

        } else if (command === "get_session_log_by_created_at") {
            let body = {
                command: command,
                customer_id: request.customer_id,
            };
            if (request.start_date) {
                body.start_date = request.start_date;
            }
            if (request.end_date) {
                body.end_date = request.end_date;
            }
            if (request.start_time) {
                body.start_time = request.start_time;
            }
            if (request.end_time) {
                body.end_time = request.end_time;
            }
            let response = axios.post("api/delete-unallocated-sessions", body);
            return response;

        } else if (command === "session_logs_for_delete_by_created_at_date") {
            let body = {
                command: command,
                customer_id: request.customer_id,
                created_at_date: request.created_at_date,
            };
            let response = axios.post("api/delete-unallocated-sessions", body);
            return response;

        } else if (command === "delete_session_log_by_created_at") {
            let body = {
                command: command,
                customer_id: request.customer_id,
                created_at_date: request.created_at_date,
            };
            let response = axios.post("api/delete-unallocated-sessions", body);
            return response;
        }

    }

    //#endregion

    //#region Support
    getCustomerSupport(request, filter, page, page_size = undefined) {
        let body = {};
        if (request != null)
            body = {
                id: request
            };
        else {
            body = {
                from_date: filter.fromDate,
                to_date: filter.toDate,
                status_row: filter.statusRow,
                search: filter.search,
            };
        }
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/customer-supports?page=" + params, body);
        return response;
    }

    SetSupport(request) {
        let body = request;
        let response = axios.post("api/create-support", body);
        return response;
    }

    SetSupportDetail(request) {
        let body = request;
        let response = axios.post("api/create-support-detail", body);
        return response;
    }

    getAdminSupport(request, filter, page, page_size = undefined) {
        let body = {};
        if (request != null)
            body = {
                id: request
            };
        else {
            body = {
                from_date: filter.fromDate,
                to_date: filter.toDate,
                status_row: filter.statusRow,
                search: filter.search,
            };
        }
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/supports?page=" + params, body);
        return response;
    }
    //#endregion

    //#region User
    // eslint-disable-next-line no-unused-vars
    // getUsers(request, search, page, page_size = undefined) {
    //     let body = {
    //         search: search
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/users?page=" + params, body);
    //     return response;
    // }

    getUsers(search_by, search, page, page_size = undefined, no_page = false) {
        let body = {
            search: search,
            search_by: search_by,
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("users response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';

        let response = axios.post(`api/users${queryString}`, body);
        return response;
    }



    SetUser(request) {
        let body = request;
        let url = (request.id != 0 ? 'api/update-user' : 'api/create-user');
        let response = axios.post(url, body);
        return response;
    }

    deleteUser(request) {
        let body = {
            user_id: request
        };
        let response = axios.post("api/delete-user", body);
        return response;
    }

    //#endregion

    //#region Customer
    // eslint-disable-next-line no-unused-vars
    getCustomers(search_by = null, search, page, page_size = undefined) {
        let body = {
            search: search,
            search_by: search_by,
        };
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/customers?page=" + params, body);
        return response;
    }

    SetCustomer(request) {
        let body = request;
        let url = 'api/save-customer';
        let response = axios.post(url, body);
        return response;
    }

    deleteCustomer(request) {
        let body = {
            customer_id: request
        };
        let response = axios.post("api/delete-customer", body);
        return response;
    }


    deleteCustomerAllData(request) {
        let body = {
            customer_id: request
        };
        let response = axios.post("api/delete-customer-all-data", body);
        return response;
    }

    //#endregion

    //#region ChargingSite
    getChargingSites(request, search, page, page_size = undefined, site_id = null, search_by = "", no_page = false) {
        let body = {
            search_by: search_by,
            search: search
        };

        if (no_page == true) {
            let response = axios.post("api/charging-site-list?no_page=true", body);
            return response;
        }

        if (request != null)
            body = {
                site_id: request.site_id,
                customer_id: request.customer_id
            };

        if (site_id != null) {
            body = {
                search: search,
                site_id: site_id
            };
        }
        //let response = axios.post("api/session-log-list?bypass_pagination=true", body);
        if (page_size != 0) {
            let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
            let response = axios.post("api/charging-site-list?page=" + params, body);
            return response;

        } else {
            let response = axios.post("api/charging-site-list?bypass_pagination=true", body);
            return response;

        }

    }

    updateChargingSite(request) {
        let body = request;
        let response = axios.post("api/charging-site-update", body);
        return response;
    }

    updateCharger(request) {
        let body = request;
        let response = axios.post("api/charger-update", body);
        return response;
    }

    updatePort(request) {
        let body = request;
        let response = axios.post("api/port-update", body);
        return response;
    }

    deleteChargingSite(request) {
        let body = {
            charging_site_id: request
        };
        let response = axios.post("api/delete-charging-sites", body);
        return response;
    }

    /**
     * Recalculate charging-site elec_region from stored location data.
     * URL keeps "uk" for historical reasons; works for any country.
     */
    resetUkElecRegion(customer_id, site_name) {
        let response = axios.post("api/reset-uk-elec-region", {
            customer_id: customer_id,
            site_name: site_name,
        });
        return response;
    }
    deleteCharger(request) {
        let body = {
            charger_id: request
        };
        // console.log("body: ", body)
        let response = axios.post("api/delete-chargers", body);
        return response;
    }
    deleteChargerPort(request) {
        let body = {
            charger_port_id: request
        };
        // console.log("body: ", body)
        let response = axios.post("api/delete-ports", body);
        return response;
    }
    //#endregion

    //#region Admin Session
    // eslint-disable-next-line no-unused-vars
    getSessions(request, page, page_size = undefined) {
        let body = request;
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/session-list-view?page=" + params, body);
        return response;
    }
    //#endregion

    //#region Baseline Params
    // eslint-disable-next-line no-unused-vars
    // getBaselineParams(request, search, page, page_size = undefined) {
    //     let body = {
    //         search: search
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/baseline-params?page=" + params, body);
    //     return response;
    // }

    getBaselineParams(search_by, search, page, page_size = undefined, no_page = false) {
        let body = {
            search: search,
            search_by: search_by,
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("baseline params response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/baseline-params${queryString}`, body);
        return response;
    }

    SetBaselineParam(request) {
        let body = request;
        let url = 'api/save-baseline-param';
        let response = axios.post(url, body);
        return response;
    }

    deleteBaselineParam(request) {
        let body = {
            id: request
        };
        let response = axios.post("api/delete-baseline-param", body);
        return response;
    }

    //#endregion

    //#region SiteBaseline Params
    // eslint-disable-next-line no-unused-vars

    // getSiteBaselineParams(request, search, page, page_size = undefined) {
    //     let body = {
    //         search: search
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/site-baseline-params?page=" + params, body);
    //     return response;
    // }

    getSiteBaselineParams(request, search, page, page_size = undefined, no_page = false) {
        let body = {
            search: search
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("site baseline params response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/site-baseline-params${queryString}`, body);
        return response;
    }



    SetSiteBaselineParam(request) {
        let body = request;
        let url = 'api/save-site-baseline-param';
        let response = axios.post(url, body);
        return response;
    }

    deleteSiteBaselineParam(request) {
        let body = {
            id: request
        };
        let response = axios.post("api/delete-site-baseline-param", body);
        return response;
    }

    /**
     * Emission intensity factor versions (not unique per region).
     * @typedef {Object} EmissionIntensity
     * @property {number} id
     * @property {string} region_name
     * @property {string} name Optional range label (max 64); not unique
     * @property {number} factor
     * @property {string} start_date YYYY-MM-DD inclusive Effective from
     * @property {string|null} end_date YYYY-MM-DD inclusive Effective till; null = still in force
     * @property {string} created_at
     * @property {string} updated_at
     */
    getEmissionIntensityList(search_by, search, page, page_size = undefined, no_page = false) {
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        if (search_by === 'region_name' && search) {
            params.push(`region_name=${encodeURIComponent(search)}`);
        }
        // console.log("baseline params response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.get(`api/factors/emission-intensities/${queryString}`);
        return response;
    }

    createEmissionIntensity(data) {
        let response = axios.post('api/factors/emission-intensities/', data);
        return response;
    }

    updateEmissionIntensity(pk, data) {
        let response = axios.patch(`api/factors/emission-intensities/${pk}/`, data);
        return response;
    }

    deleteEmissionIntensity(pk) {
        let response = axios.delete(`api/factors/emission-intensities/${pk}/`);
        return response;
    }

    getEmissionIntensityRegionList() {
        let response = axios.get('api/factors/emission-intensities/regions/');
        return response;
    }
    //#endregion

    //#region Participants
    getParticipants(page, search, page_size = undefined, search_by, no_page = false) {
        let body = {
            search: search,
            search_by: search_by,
        };
        if (no_page == true) {
            let response = axios.post("api/participants?no_page=true", body);
            return response;
        }
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/participants?page=" + params, body);
        return response;
    }

    SetParticipant(request) {
        let body = request;
        let url = 'api/save-participant';
        let response = axios.post(url, body);
        return response;
    }

    deleteParticipant(request) {
        let body = {
            duid: request
        };
        let response = axios.post("api/delete-participant", body);
        return response;
    }

    //#endregion

    //#region History Log
    // eslint-disable-next-line no-unused-vars
    getHistoryLogs(page, filter, page_size = undefined, no_page = false) {
        let body = filter;
        if (no_page == true) {
            let response = axios.post("api/history-logs?no_page=true", body);
            return response;
        }
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/history-logs?page=" + params, body);
        return response;
    }
    //#endregion

    //#region Bucket Files
    getBucketFiles(page, filter, page_size = undefined, no_page = false) {
        const params = {
          ...filter,
          page: page || 1,
          page_size: page_size || 50,
          no_page: no_page || false,
        };
        let response = axios.get("api/bucket/files/", { params });
        return response;
    }

    uploadBucketFile(file, customerId=null) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("customer_id", customerId);
      let response = axios.post("api/bucket/files/", formData);
      return response
    }

    bucketFileBulkDelete(request) {
        let body = {
            ids: request.ids
        };
        let response = axios.post("api/bucket/files/bulk-delete/", body);
        return response;
    }

    logBucketFileAction(body) {
        let response = axios.post("api/bucket/files/action-log/", body);
        return response;
    }
    //#endregion

    //#region Fleet
    setFleet(request) {
        let body = {
            by_panel: true,
            content: request
        };
        let response = axios.post("api/upload-vehicle", body);
        return response;
    }
    //#endregion

    //#region Fleet Analytics
    FleetAnalyticsCharts(request) {
        let body = {
            command: null,
            customer_id: null,
        };

        if(request != null && request.command != null && request.command != "") {
            body.command = request.command;
        }

        if(request != null && request.customer_id != null && request.customer_id != "") {
            body.customer_id = request.customer_id;
        }

        // console.log("fleet analytics charts body: ", body);
        let response = axios.post("api/fleet-analytics-charts", body);
        return response;
    }

    FleetAnalyticsTablesCard(request, page, page_size, no_page = false) {
        const controller = new AbortController();

        let body = {
            customer_id: null,
            command: null,
            search_by: null,
            search: null,
            order_by: null,
            order_direction: null,
        };

        let params = [];
        if(page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if(page_size == undefined) {
            params.push('page_size=50');
        }
        if(page == undefined) {
            params.push('page=1');
        }
        if(page !== undefined) {
            params.push(`page=${page}`);
        }
        if(no_page) {
            params.push('no_page=true');
        }

        if(request != null) {
            if(request.customer_id != null && request.customer_id != "") {
                body.customer_id = request.customer_id;
            }
            if(request.command != null && request.command != "") {
                body.command = request.command;
            }
            if(request.search_by != null && request.search_by != "") {
                body.search_by = request.search_by;
            }
            if(request.search != null && request.search != "") {
                body.search = request.search;
            }
            if(request.order_by != null && request.order_by != "") {
                body.order_by = request.order_by;
            }
            if(request.order_direction != null && request.order_direction != "") {
                body.order_direction = request.order_direction;
            }
        }

        // console.log("fleet analytics tables card body: ", body);
        // console.log("fleet analytics tables card params: ", params.join('&'));

        let response = axios.post("api/fleet-analytics-table" + "?" + params.join('&'), body, { signal: controller.signal });
        return {
            response: response,
            controller: controller
        };
    }

    //#region On Site Renewable Params
    getOnSiteRenewableCustomers() {
        return axios.get("api/on-site-renewable");
    }

    // eslint-disable-next-line no-unused-vars
    getOnSiteRenewable(search_by, search, page, page_size = undefined, no_page = false, filters = {}) {
        let body = {
            search: search,
            search_by: search_by,
        };
        if (filters.customer_id != null && filters.customer_id !== '') {
            body.customer_id = filters.customer_id;
        } else {
            body.customer_id = null;
        }
        if (filters.start_time) {
            body.start_time = filters.start_time;
        } else {
            body.start_time = null;
        }
        if (filters.end_time) {
            body.end_time = filters.end_time;
        } else {
            body.end_time = null;
        }
        if(no_page == true) {
            let response = axios.post("api/on-site-renewable?no_page=true", body);
            return response;
        }
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/on-site-renewable?page=" + params, body);
        return response;
    }

    SetOnSiteRenewable(request) {
        let body = request;
        let url = 'api/save-on-site-renewable';
        let response = axios.post(url, body);
        return response;
    }

    deleteOnSiteRenewable(request) {
        let body = {
            id: request
        };
        let response = axios.post("api/delete-on-site-renewable", body);
        return response;
    }

    //#endregion

    // #region Renewable energy analytics
    renewableEnergyAnalytics(request, page, page_size = undefined) {
        // console.log("request body", request);
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/renewable-energy-analytics?page=" + params, request);
        return response;
    }

    //#region MonitoringPeriods
    // eslint-disable-next-line no-unused-vars
    // getMonitoringPeriods(request, search, page, page_size = undefined) {
    //     let body = {
    //         search: search
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/monitoring-periods?page=" + params, body);
    //     return response;
    // }

    getMonitoringPeriods(search_by, search, page, page_size = undefined, no_page = false) {
        let body = {
            search: search,
            search_by: search_by,
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("monitoring periods response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/monitoring-periods${queryString}`, body);
        return response;
    }

    SetMonitoringPeriod(request) {
        let body = request;
        let url = 'api/save-monitoring-periods';
        let response = axios.post(url, body);
        return response;
    }

    DeleteMonitoringPeriod(request) {
        let body = {
            id: request
        };
        let response = axios.post("api/delete-monitoring-periods", body);
        return response;
    }

    //#endregion

    //#region Battery Intensities
    // eslint-disable-next-line no-unused-vars
    // getBatteryIntensities(request, search, page, page_size = undefined) {
    //     let body = {
    //         search: search
    //     };
    //     let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
    //     let response = axios.post("api/battery-intensities?page=" + params, body);
    //     return response;
    // }

    getBatteryIntensities(request, search, page, page_size = undefined, no_page = false) {
        let body = {
            search: search
        };
        let params = [];
        if (page == undefined) {
            params.push('page=1');
        }
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        if (page_size !== undefined) {
            params.push(`page_size=${page_size}`);
        }
        if (no_page) {
            params.push('no_page=true'); // Bypass pagination
        }
        // console.log("battery intensities response:", params);
        let queryString = params.length > 0 ? '?' + params.join('&') : '';
        let response = axios.post(`api/battery-intensities${queryString}`, body);
        return response;
    }

    SetBatteryIntensities(request) {
        let body = request;
        let url = 'api/save-battery-intensity';
        let response = axios.post(url, body);
        return response;
    }

    DeleteBatteryIntensities(request) {
        let body = {
            id: request
        };
        let response = axios.post("api/delete-battery-intensity", body);
        return response;
    }

    //#endregion

    //#region Vehicles
    // eslint-disable-next-line no-unused-vars
    getVehicles(request, search, page, page_size = undefined, search_by = null, no_page = false) {
        let body = {
            search: search,
            search_by: search_by,
        };
        if (no_page == true) {
            let response = axios.post("api/vehicles?no_page=true", body);
            return response;
        }
        let params = (page == undefined ? 1 : page) + (page_size != undefined ? '&page_size=' + page_size : '');
        let response = axios.post("api/vehicles?page=" + params, body);
        return response;
    }

    SetVehicles(request) {
        let body = request;
        let url = 'api/save-vehicle';
        let response = axios.post(url, body);
        return response;
    }

    DeleteVehicles(request) {
        let body = {
            id: request
        };
        let response = axios.post("api/delete-vehicle", body);
        return response;
    }

    //#endregion

    //#region abatement within radius
    // eslint-disable-next-line no-unused-vars
    abtWithinRadius(request) {
        let body = {
            lat: request.lat,
            lng: request.lng,
            unit: request.unit,
            radius: request.radius,
            start_date: request.start_date,
            end_date: request.end_date,
            customer_id: request.customer_id,
        };
        let response = axios.post("api/abt_in_radius", body);
        return response;
    }
    //#endregion

    // #region Charger Delete admin panel
    /*
    * delete
    * charging sites, chargers, ports for selected customer id
    * and selected date time (to second)
    */
    deleteChargerAdminPanel(request) {
        let body = {
            customer_id: request.customer_id,
            delete_by_created_at_datetime: request.dateTime,
            option: request.option,
        };
        // console.log('body', body);
        let response = axios.post("api/bulk-delete-charger", body);
        return response;
    }

    /*
    * Get distinct port, charger, site created_at list for delete table
    */
    getDistinctCreatedAtList(customer_id) {
        if (customer_id != null && customer_id != undefined && customer_id != '') {
            let response = axios.get("api/bulk-delete-charger?customer_id=" + customer_id);
            return response;
        }
        console.log('customer_id is null');
    }

    // region Cha Date Inconsis
    getChargerDateInconsistency(customer_id) {
        if (customer_id != null && customer_id != undefined && customer_id != '') { 
            let response = axios.post("api/charger-date-inconsistency-detection?customer_id=" + customer_id);
            return response;
        } else {
            console.log('customer_id is null');
            return null;
        }
    }
    //#endregion
    /*
    * Get UK emission intensity data
    */
    customPeriodUkEmissionIntensity(request) {
        let body = {
            start_time: request.start_time || null,
            end_time: request.end_time || null,
            command: request.command || null,
        }
        let response = axios.post("api/custom-period-uk-intensity-update", body);
        return response;
    }

    // test connection to the api
    testUkEmissionIntensity() {
        let response = axios.get("api/custom-period-uk-intensity-update");
        return response;
    }

    // get sessions for abatement calculation
    getSessionsForAbatementCalculation(request) {
        let body = {
            customer_id: request.customer_id,
            start_date: request.start_date,
            end_date: request.end_date,
            charger_name: request.charger_name || null,
            site_name: request.site_name || null,
        };
        if (request.mp_id != null) {
            body.mp_id = request.mp_id;
        } else {
            return Promise.reject(new Error("Monitoring period ID is required"));
        }
        let response = axios.post("api/get-sessions-for-abatement-calc", body);
        return response;
    }

    //#region Generate Sessions with Abatement csv files
    getListOfSessionsWithAbatement(request) {
        if (request == null || request.mp_id == null || request.mp_id === "") {
            return Promise.reject(new Error("Monitoring Period ID is required."));
        }
        const params = new URLSearchParams({ mp_id: request.mp_id });
        if (request.category != null && request.category !== "") {
            params.append("category", request.category);
        }
        let response = axios.get(`api/generate-large-sessions-csv?${params.toString()}`);
        return response;
    }

    generateSessionsWithAbatement(request) {
        let body = {
            mp_id: request.mp_id,
            category: request.category,
            customers: request.customers,
        };
        let response = axios.post("api/generate-large-sessions-csv", body);
        return response;
    }
    //#endregion




}

export default new UserService();
